module.exports = __webpack_public_path__ + "static/7-6862a76759e8d1c68411c23ac44948f7.woff";